"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const pit_types_1 = require("./pit.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataContractor: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        pit: '',
        is_active: true,
        modified_by: '',
        modified_date: new Date(),
        created_by: '',
        created_date: new Date(),
        is_deleted: false,
        description: '',
        contractor_data: [],
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const pitReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [pit_types_1.pitTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [pit_types_1.pitTypes.GET_DETAIL]: (state, action) => {
        const { dataContractor } = action.payload;
        return Object.assign(Object.assign({}, state), { dataContractor });
    },
    [pit_types_1.pitTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates,
            dataGrid, isLoading: false });
    },
    [pit_types_1.pitTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [pit_types_1.pitTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, isLoading: true, dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [pit_types_1.pitTypes.ON_DELETE]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [pit_types_1.pitTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [pit_types_1.pitTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [pit_types_1.pitTypes.SET_ERROR]: (state, action) => {
        const { isError, errorCode, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError, errorCode, errorMessage, isLoading: false });
    },
    [pit_types_1.pitTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    }
});
exports.default = pitReducer;
